var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { ReactComponent as CloseIcon } from '../../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container';
import { FormItemTypes } from '../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity';
import { Typography, useMediaQuery } from '@mui/material';
var CustomerComplaintMobileView = function (_ref) {
    var data = _ref.data, onClose = _ref.onClose;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var referncevaluesElements = [{
            type: FormItemTypes.CardComponent,
            name: '',
            containerProps: {
                spacing: 0
            },
            columnSize: 12,
            contentProps: {
                spacing: 0
            },
            sx: {
                border: 'none',
                p: 0
            },
            elements: [
                // {
                //     type: FormItemTypes.Typography,
                //     name: 'AFRnumber',
                //     fontWeight: 'strong',
                //     columnSize: true,
                //     containerProps: { spacing: 0, padding: '12px 12px 0px 12px' }
                // },
                {
                    type: FormItemTypes.CardComponent,
                    name: '',
                    columnSize: 12,
                    containerProps: {
                        m: 0,
                        spacing: 0,
                        padding: '12px'
                    },
                    sx: {
                        bgcolor: 'secondary.50',
                        border: 'none',
                        p: 1
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 12,
                            label: 'When',
                            children: 'Both',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            textAlign: 'end',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 12,
                            label: 'What',
                            children: 'A little about the company',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            textAlign: 'end',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 12,
                            label: 'Where',
                            children: 'All road',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            textAlign: 'end',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm'
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: '',
                            columnSize: 12,
                            label: 'Vehicle speed',
                            children: '70Kms',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            textAlign: 'end',
                            containerProps: {
                                display: 'inline-flex',
                                justifyContent: 'space-between',
                                alignItems: 'baseline',
                                gap: 1,
                                spacing: 0
                            },
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true,
                                fontWeight: 'medium',
                                fontSize: 'sm',
                                textOverflow: 'unset'
                            }
                        }]
                }
            ]
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            padding: '20px',
            elements: [{
                    type: FormItemTypes.Typography,
                    name: "Title",
                    label: 'Customer complaints (Reference values)',
                    children: '',
                    columnSize: true,
                    fontSize: 'lg',
                    fontWeight: 'medium',
                    labelTypographyProps: {
                        fontSize: 'xl',
                        fontWeight: 'strong',
                        color: 'text.primary'
                    },
                    color: 'text.secondary'
                }, {
                    type: FormItemTypes.IconButton,
                    name: '',
                    children: /*#__PURE__*/ React.createElement(CloseIcon, {
                        color: "text.secondary",
                        height: '12px',
                        width: '12px'
                    }),
                    columnSize: 0,
                    onClick: function () {
                        onClose(false);
                    },
                    sx: {
                        padding: '12px'
                    }
                }]
        }, {
            type: FormItemTypes.Divider,
            name: 'name',
            variant: 'fullWidth',
            columnSize: 12
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            sx: {
                padding: {
                    xs: '0px 16px 16px 16px',
                    md: '0px 24px 20px 24px'
                }
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    border: '1px solid ',
                    borderColor: 'secondary.200',
                    borderRadius: 1.5,
                    elements: [{
                            type: FormItemTypes.List,
                            name: 'ReferanceValueData',
                            columnSize: 12,
                            value: [{
                                    id: 1
                                }, {
                                    id: 2
                                }, {
                                    id: 3
                                }],
                            disableCheckboxSelection: true,
                            getRowHeight: function () { return 'auto'; },
                            disableBorder: true,
                            containerProps: {
                                spacing: 0
                            },
                            columns: [{
                                    field: 'customercomplaint',
                                    flex: 1,
                                    renderCell: function (_ref2) {
                                        var row = _ref2.row;
                                        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                                            variant: "h3",
                                            p: 1.5
                                        }, 'FFR-3456789'));
                                    }
                                }],
                            elements: referncevaluesElements
                        }]
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        mode: "edit",
        getFormAPI: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, ({
                        data: data,
                        success: true
                    })];
            });
        }); },
        gridProps: {
            spacing: 0,
            rowGap: 2
        }
    }));
};
export default CustomerComplaintMobileView;
